import { Action } from '@ngrx/store';
import { User } from '../../model/User';

export enum UserActionTypes {
  InitUser = 'InitUser',
  SelectAccount = 'SelectAccount',
  DeSelectAccount = 'DeSelectAccount',
  Logout = 'Logout',
  SetCsrfToken = 'SetCsrfToken',
  ClearCsrfToken = 'ClearCsrfToken',
  HydrateState = 'HydrateState',
}

export class InitUser implements Action {
  readonly type = UserActionTypes.InitUser;

  constructor(
    public payload: User,
    public selectedAccount: string,
  ) {}
}

export class SelectAccount implements Action {
  readonly type = UserActionTypes.SelectAccount;

  constructor(public payload: string) {}
}

export class DeSelectAccount implements Action {
  readonly type = UserActionTypes.DeSelectAccount;
}

export class Logout implements Action {
  readonly type = UserActionTypes.Logout;
}

export class SetCsrfToken implements Action {
  readonly type = UserActionTypes.SetCsrfToken;

  constructor(
    public parameterName: string,
    public token: string,
  ) {}
}

export class ClearCsrfToken implements Action {
  readonly type = UserActionTypes.ClearCsrfToken;
}

export class HydrateState implements Action {
  readonly type = UserActionTypes.HydrateState;

  constructor(
    public user: User,
    public isAuthenticated: boolean,
    public selectedAccount: string,
    public csrfToken: string | null,
    public csrfParameterName: string | null,
  ) {}
}

export type UserActions =
  | InitUser
  | SelectAccount
  | DeSelectAccount
  | Logout
  | SetCsrfToken
  | ClearCsrfToken
  | HydrateState;
